import React from 'react';
import OrderManagement from './OrderManagement';

const OrderManagementPage = () => {
  return (
    <div>
      <OrderManagement />
    </div>
  );
};

export default OrderManagementPage;
